(function () {
  function normalizeQuery(value) {
    return String(value || '').trim().replace(/[\uFF0A*]+$/g, '');
  }

  function isSkuQuery(value) {
    var query = normalizeQuery(value);

    if (!query) return false;
    if (/[\u3040-\u30ff\u3400-\u9fff]/.test(query)) return false;

    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*-)[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/.test(query);
  }

  function escapeRegExp(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getStarredSkuFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var rawQuery = params.get('q') || '';
    var cleanQuery = normalizeQuery(rawQuery);

    if (!/[\uFF0A*]$/.test(rawQuery)) return null;
    if (!isSkuQuery(cleanQuery)) return null;

    return {
      raw: rawQuery,
      clean: cleanQuery
    };
  }

  function cleanSearchInputs(cleanQuery) {
    document.querySelectorAll('input[name="q"]').forEach(function (input) {
      if (normalizeQuery(input.value) === cleanQuery) {
        input.value = cleanQuery;
      }
    });
  }

  function cleanVisibleText(rawQuery, cleanQuery) {
    var patterns = [rawQuery, cleanQuery + '*', cleanQuery + '\uFF0A']
      .filter(Boolean)
      .map(escapeRegExp);

    if (!patterns.length) return;

    var matcher = new RegExp(patterns.join('|'), 'g');
    var skipTags = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|OPTION)$/;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('*') === -1 && node.nodeValue.indexOf('\uFF0A') === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        if (node.parentElement && skipTags.test(node.parentElement.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      node.nodeValue = node.nodeValue.replace(matcher, cleanQuery);
    }

    document.title = document.title.replace(matcher, cleanQuery);
  }

  function hideSkuSearchAsterisk() {
    var sku = getStarredSkuFromUrl();
    if (!sku) return;

    cleanSearchInputs(sku.clean);
    cleanVisibleText(sku.raw, sku.clean);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('.yl-search-form, form[action="/search"], form[action*="/search"]')) return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var query = normalizeQuery(input.value);
      input.value = isSkuQuery(query) ? query + '*' : query;
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideSkuSearchAsterisk);
  } else {
    hideSkuSearchAsterisk();
  }

  window.addEventListener('pageshow', hideSkuSearchAsterisk);
})();